import { render, staticRenderFns } from "./GeneraIErrorIcon.vue?vue&type=template&id=b88376c6"
import script from "./GeneraIErrorIcon.vue?vue&type=script&lang=js"
export * from "./GeneraIErrorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports